import { render, staticRenderFns } from "./simplifyOwnerRooms.vue?vue&type=template&id=c2e4571c&scoped=true"
import script from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerRooms.vue?vue&type=style&index=0&id=c2e4571c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e4571c",
  null
  
)

export default component.exports